import { getConfig } from 'config/config-helper';

interface UsePlatformTokenResult {
  token: string | null;
  graphQlApiEndpoint: string;
  dataopsLiveBaseUrl: string;
}

export default function usePlatformToken(): UsePlatformTokenResult {
  const rawToken = localStorage.getItem('ROCP_token')?.replaceAll('"', '') ?? '';
  const token = rawToken !== '' ? rawToken : null;
  const config = getConfig();

  return {
    token,
    graphQlApiEndpoint: config.dataopsGraphQlApiEndpoint,
    dataopsLiveBaseUrl: config.dataopsliveBaseUrl,
  };
}
